"use client"

import Link from "next/link"
import { forwardRef, useState, type ComponentPropsWithoutRef } from "react"

type Props = ComponentPropsWithoutRef<typeof Link>

// Public navigation keeps normal anchors and client navigation, but only warms
// a destination after the visitor points at or focuses its link. Explicit
// prefetch={false} remains disabled, including for CMS article links.
const IntentLink = forwardRef<HTMLAnchorElement, Props>(function IntentLink(
  { href, prefetch, onPointerEnter, onFocus, ...props },
  ref
) {
  const [intendedHref, setIntendedHref] = useState<Props["href"]>()
  return (
    <Link
      {...props}
      ref={ref}
      href={href}
      prefetch={intendedHref === href ? prefetch ?? null : false}
      onPointerEnter={(event) => {
        onPointerEnter?.(event)
        // Touch scrolling can enter a link without intending to follow it.
        if (!event.defaultPrevented && event.pointerType !== "touch" && prefetch !== false) {
          setIntendedHref(href)
        }
      }}
      onFocus={(event) => {
        onFocus?.(event)
        if (!event.defaultPrevented && prefetch !== false) setIntendedHref(href)
      }}
    />
  )
})

export default IntentLink
